import { render, staticRenderFns } from "./ProblemStatistic.vue?vue&type=template&id=22790f48"
import script from "./ProblemStatistic.vue?vue&type=script&lang=js"
export * from "./ProblemStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports